import React from 'react';
import PropTypes from 'prop-types';
import scrollToElement from 'scroll-to-element';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './styles.module.scss';

const ValueProp = ({ id, image, title, description, returnTo, flipped }) => (
  <div id={id} className={styles.valueProp}>
    <img className={`order-md-${flipped ? 1 : 2}`} src={image} alt="" />
    <div className={`order-md-${flipped ? 2 : 1}`}>
      <h3>{title}</h3>
      <p>{description}</p>
      {returnTo && (
        <div onClick={() => scrollToElement(returnTo)} className={styles.returnLink}>
          <span><FontAwesomeIcon icon="arrow-square-up" fixedWidth className="mr-2" />Return to top</span>
        </div>
      )}
    </div>
  </div>
);

ValueProp.propTypes = {
  id: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  flipped: PropTypes.bool
};

export default ValueProp;
